import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import CMSService from "@/services/CMSService.js";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            pageTitle: "",
            pageContent: ""
        };
    },
    metaInfo() {
        return {
            title: `Contacta al equipo de YourDictionary`,
            meta: [
                {
                    name: "description",
                    content: `Tus comentarios y sugerencias nos ayudan a mejorar YourDictionary. Cuéntanos cómo podemos ayudarte a aprender más y mejor.`
                }
            ]
        };
    },
    methods: {
        fetchContent() {
            CMSService.getContactoYDR().then(
                response => {
                    const data = response.data.data;
                    this.pageTitle = data.title;
                    this.pageContent = data.body;
                },
                err => {
                    this.status.err = true;
                }
            );
        }
    },
    mounted() {
        this.fetchContent();
    }
};



// WEBPACK FOOTER //
// ./src/pages/Contacto/Contacto.js